import { InjectedConnector } from '@web3-react/injected-connector';

export const injectedConnector = new InjectedConnector({
    supportedChainIds: [
      1, // Mainnnet
      57,// SYS Mainnnet
      5700,// SYS Tesnnet
    ],
  });
